import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { DevicePid, EffectIndex, KK } from '@/define/define'

import list_icon from '@/assets/img/device/ra68/list_icon.png'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { mer68VKCodes } from '../keycode/vkeycode'
import { BaseDevice, CustomLayout } from '@/profiles/base_device'
import { LIGHT_EFFECT_LIST_MG63 } from '../../light/light_effect_list'

export class RA68_HuoChaiRen extends BaseDevice {
  name: string = 'RA68'
  icon: string = list_icon
  width: number = 792
  vkcodes = mer68VKCodes
  square = getDeviceKeySquare(DevicePid.CarotmasMer68)

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_MG63

  inoperableKeys: KK[] = [0x01]
  fnDisableKeys: KK[] = [0x16, 0x1b, 0x2f, 0x30, 0x31, 0xe3, 0x52, 0x50, 0x51, 0x4f, 0x29, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x2d, 0x2e, 0xe6]
  customLayout: CustomLayout = {
    0x2a: this.createSquare(2, 2, 74),
    0x2b: this.createSquare(2, 2, 58),
    0x31: this.createSquare(2, 2, 57),
    0x39: this.createSquare(2, 2, 67),
    0x28: this.createSquare(2, 2, 91),
    0xe1: this.createSquare(2, 2, 90),
    0xe0: this.createSquare(2, 2, 50),
    0xe2: this.createSquare(2, 2, 50),
    0xe3: this.createSquare(2, 2, 50),
    0xe5: this.createSquare(2, 2, 68),
    0x2c: this.createSquare(2, 2, 262),
  }
  speedAllowValues: number[] = generateArray(0, 101)
  lightAllowValues: number[] = generateArray(0, 101)
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = false
  magneticAxis: boolean = true
  lockWin: boolean = true

  // 0 ~ 0xff
  // sleepTimeValues: number[] = [0, 10, 20, 30, 60, 90, 120, 150, 200, 255]
}
